import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {SelectFilterModule} from "../../../../components/common/select-filter/select-filter.module";
import {PaymentTypeSelectFilterComponent} from "./payment-type-select-filter.component";
import {MultipleSelectFilterModule} from "../../../core/component/multiple-select-filter/multiple-select-filter.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        SelectFilterModule,
        MultipleSelectFilterModule,
    ],
    declarations: [
        PaymentTypeSelectFilterComponent
    ],
    exports: [
        PaymentTypeSelectFilterComponent
    ]
})
export class PaymentTypeSelectFilterModule {
}